/* 下拉列表请求 */
export default {
  ws: {},
  setWs: function (newWs) {
    this.ws = newWs
  }
}
